import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { TELEMETRY_API } from "../../constants/serverConfig";

export function setCertifiedDatasetsFunction(
  setModalData,
  setCertifiedDatasets
) {
  return async (token, COLUMN_API, node) => {
    axios
      .get(COLUMN_API, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        let infoData = res.data;

        console.log("infoData", infoData);

        setModalData(infoData.dataset);

        setCertifiedDatasets(infoData.dataset?.certification);
      });
  };
}

export function setMetricsDataFunction(
  setIsFetching,
  clickedNodeInfo,
  setmetricsData
) {
  return (token, METRICS_API) => {
    setIsFetching(true);
    axios.get(METRICS_API).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.objectId === `${clickedNodeInfo}`
      );
      let metricsdata = [];
      _.map(filteriddata, (da) => {
        let unixupdatedate = moment.unix(da.batchDate);
        return metricsdata.push({
          metricValue: da.metricValue,
          updatedAt: unixupdatedate.format("MMM D, YYYY"),
        });
      });
      setmetricsData(metricsdata);
      setIsFetching(false);
    });
  };
}

export function setPastOneMonthUserVisitFunction(
  clickedNodeInfo,
  setPastOneMonthUserVisit
) {
  return (token) => {
    axios
      .get(
        TELEMETRY_API +
          "util/users/count/datasetId?datasetId=" +
          `${clickedNodeInfo}`
      )
      .then((res) => {
        setPastOneMonthUserVisit(res.data);
      })
      .catch((error) => {
        // toast.error("Error while fetching the past one month user data", {
        //   toastId: "onemonthuserdata",
        //   position: "top-right",
        //   autoClose: 6000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        // });
        console.error(error)
      });
  };
}
